import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps {
  children: ReactNode;
  level?: 'sub' | 'section';
  className?: string;
  style?: React.CSSProperties;
}

// The bare h4/h5 element defaults these mirror live in src/styles/base.css, so
// CMS-authored markup still gets them. Utilities beat @layer base, so a caller
// passing `text-2xl` overrides both.
const LEVEL = {
  sub: 'text-type-blue text-[2rem] leading-[1.1] max-[600px]:text-[1.5rem] max-[600px]:leading-none max-[400px]:text-[1.375rem]',
  section:
    'text-type-blue text-[1.5rem] leading-[1.1] font-black max-[400px]:text-[1.375rem] max-[400px]:leading-none',
};

const Header = ({
  children,
  level = 'sub',
  className,
  ...props
}: IProps): ReactElement => {
  const HeaderEl = level === 'sub' ? 'h4' : 'h5';

  return (
    <HeaderEl className={twMerge('header', LEVEL[level], className)} {...props}>
      {children}
    </HeaderEl>
  );
};

export default Header;
